/**
 *
 */
const jss = (theme) => {
    const { colors, typography } = theme['foundations-library']
    const listLink = {
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: colors.primary[500]
    }

    return {
        wrapper: {
            width: '100%'
        },
        label: {
            marginBottom: 15,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2
        },
        required: {
            color: colors.destructive[500]
        },
        dropArea: {
            width: '100%',
            minHeight: 270,
            padding: '40px 24px',
            borderRadius: 24,
            border: `2px dashed ${colors.neutral[100]}`,
            backgroundColor: '#FFFFFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            cursor: 'pointer',
            transition: 'border-color 120ms ease, background-color 120ms ease',
            '&:focus': {
                outline: 'none'
            },
            '&.drag-active': {
                borderColor: ({ accentBorderColor }) => accentBorderColor,
                backgroundColor: ({ accentSoftColor }) => accentSoftColor,
                '& .dropzone-icon-wrapper': {
                    backgroundColor: ({ accentSoftColor }) => accentSoftColor
                }
            },
            '&.disabled': {
                cursor: 'not-allowed',
                '&:has(.dropzone-limit-overlay)': {
                    opacity: 1
                }
            }
        },
        dropAreaOverlay: {
            position: 'relative',
            overflow: 'hidden'
        },
        overlay: {
            position: 'absolute',
            inset: 0,
            borderRadius: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1
        },
        loadingOverlay: {
            backgroundColor: '#FFFFFF'
        },
        limitOverlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            padding: '24px'
        },
        limitMessage: {
            ...typography.h6,
            color: '#FFFFFF',
            textAlign: 'center',
            maxWidth: 760
        },
        content: {
            maxWidth: 420,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column'
        },
        iconWrapper: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: colors.neutral[100],
            color: colors.neutral[500],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 20
        },
        title: {
            ...typography.h8,
            color: colors.neutral[700],
            marginBottom: 6
        },
        helperText: {
            ...typography.body2,
            color: colors.neutral[700],
            marginBottom: 20
        },
        files: {
            marginBottom: 16,
            padding: 10,
            borderRadius: 5,
            border: `1px solid ${colors.neutral[400]}`,
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        },
        fileRow: {
            minHeight: 26,
            display: 'flex',
            alignItems: 'center',
            gap: 5
        },
        listLink,
        fileName: {
            textDecoration: 'underline',
            cursor: 'pointer'
        },
        removeButton: {
            minWidth: 70
        },
        dialogMessage: {
            marginBottom: 24,
            color: colors.neutral[700]
        },
        dialogAction: {
            display: 'flex',
            justifyContent: 'center'
        }
    }
}

export default jss
